export default __webpack_public_path__ + "static/media/ASESORIA_TECNICA.57bcda31.jpg";